import { CheckBox, RecordView, ValueView } from "web/components"
import { useLayouts } from "web/hooks/data"
import { isNonEmptyArray } from "web/services/helpers"

export default function TopicSection({
  subjectType,
  topic,
  data,
  onClick,
  onSelectionChanged,
}) {
  const layouts = useLayouts({ subjectType, topicId: topic.id })
  const summaryLayout = layouts.find((layout) => layout.name === "Summary")

  function handleSelectionChanged() {
    onSelectionChanged({ ...data, selected: !data.selected })
  }

  if (!isNonEmptyArray(summaryLayout.fields)) {
    return null
  }

  const fields = [...summaryLayout.fields]

  const titleField = fields.shift()
  const titleFieldValue = data.values[titleField.key] || {
    value: {
      value: `No ${titleField.label} Value`,
    },
  }

  return (
    <div className="border-t border-neutral-8 first:border-t-0">
      <div className="flex overflow-hidden bg-neutral-9 text-sm">
        <div className="flex-grow p-2">
          <ValueView {...titleFieldValue} />
        </div>
        <div className="h-inherit my-auto px-2">
          <CheckBox
            value={{ value: data.selected || false }}
            onChange={handleSelectionChanged}
            showValueLabel={false}
          />
        </div>
      </div>
      <div onClick={onClick}>
        <div className="p-2 text-sm">
          <RecordView data={data} fields={fields} fieldLimit={6} />
        </div>
      </div>
    </div>
  )
}
